import styled from 'styled-components'

export const Navigation = styled.nav`
    width: 100%;
    margin: ${({ landing }) => landing ? '0 0 24px' : '20px 0 24px'};
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
    display: flex;
    gap: clamp(18px, 3vw, 34px);
    overflow-x: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
`;

export const NavigationItem = styled.a`
    position: relative;
    flex: 0 0 auto;
    padding: 0 1px 11px;
    color: ${({ theme }) => theme.palette.colors.muted};
    font-family: Lato, sans-serif;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.2s ease;

    &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: -1px;
        left: 0;
        height: 2px;
        background: ${({ theme }) => theme.palette.blue.main};
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.24s ease;
    }

    &:hover, &:focus-visible, &.active { color: ${({ theme }) => theme.palette.colors.text}; }
    &.active::after { transform: scaleX(1); }
    &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 5px; }
    @media (prefers-reduced-motion: reduce) { &, &::after { transition: none; } }
`;
